import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { transaksiKeluarTable as transaksiKeluarTableAkuntan } from "./transaksiKeluarTable";
import { transaksiKeluarDetailTable as transaksiKeluarDetailTableAkuntan } from "./transaksiKeluarDetailTable";

// API
import {
  getDataTransKeluar as getDataTransKeluarAkuntan,
  deleteTransaksiKeluar as deleteTransaksiKeluarAkuntan,
  insertNewTransaksiKeluar as insertNewTransaksiKeluarAkuntan,
} from "./api/transaksiKeluarAPI";

// Component
import CardTableNoAdd from "components/Cards/CardTableNoAdd";
import ConfirmModal from "components/Modal/ConfirmModal";

import toast, { Toaster } from "react-hot-toast";
import FormCustom from "components/Forms/FormCustom";
import { transaksiKeluarFormData as transaksiKeluarFormDataAkuntan } from "./transaksiKeluarFormData";

export default function TransaksiKeluarAkuntan() {
  const history = useHistory();

  const [dataTable, setDataTable] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const [active, setActive] = useState(false);

  const [typeSearch, setTypeSearch] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  // State for Tabke Detail Transaksi Keluar
  const [showDetailTransaksi, setShowDetailTransaksi] = useState(false);
  const [detailTransaksi, setDetailTransaksi] = useState(false);

  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  const [deletePopUp, setDeletePopUp] = useState({ show: false, id: null });

  // State for Input New Transaksi Keluar
  const [addForm, setAddForm] = useState(false);
  const [formData, setFormData] = useState(null);
  const [formDataArr, setFormDataArr] = useState([]);

  // Component is Active?
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  // Load Data Table
  useEffect(() => {
    if (active === true) {
      setIsLoading(true);
      getDataTransKeluarAkuntan()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
    }

    return () => {
      // setFormData(null);
    };
  }, [active]);

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  // Handle when searching changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getDataTransKeluarAkuntan(typeSearch)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getDataTransKeluarAkuntan()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [typeSearch]);

  // Handle When Page Change
  const changePage = (selected) => {
    setPageNumber(selected);
  };

  // Handle when User want to see detail transaksi Keluar
  const handleGetDetail = (rowData) => {
    // Lihat Detail Transaksi
    setActive(false);
    setShowDetailTransaksi(true);

    // Tambahkan Data Detail Transaksi
    setDetailTransaksi(rowData.detail_transaksi_keluar);
  };

  // Handle when user click cancel button in detail transaksi keluar
  const handleCancelButton = () => {
    setShowDetailTransaksi(false);
    setAddForm(false);
  };

  // Handle when User Click Delete Button
  const handleDelete = (rowData) => {
    setDeletePopUp({
      show: true,
      id: rowData.id_transaksi_keluar,
    });
  };

  // Handle when user confirm to delete data
  const handleDeleteTrue = () => {
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deleteTransaksiKeluarAkuntan(deletePopUp.id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }
  };

  // Handle when user deny to confirm delete data
  const handleDeleteFalse = () => {
    setDeletePopUp({
      show: false,
      id: null,
    });
  };

  // Handle End Submit Process
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });
    setFormData(null);
    setAddForm(false);
    setIsLoading(false);
  };

  // Check if request failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  });

  // Check if request success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setShowDetailTransaksi(false);
        setActive(true);
        history.push("/transaction/transaksiKeluar");
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray !== []) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);
    }
    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Clear Form Data when first time load component
  useEffect(() => {
    setFormData(null);
  }, []);

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(transaksiKeluarFormDataAkuntan());

    return () => {
      setFormDataArr([]);
    };
  }, []);

  // Handle when user click add button
  function handleInsert(rowData) {
    setActive(false);
    setFormData({ id_anggaran_pengeluaran: rowData.id_anggaran_pengeluaran });
    setAddForm(true);
  }

  // Handle when user submit new data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    insertNewTransaksiKeluarAkuntan(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(endSubmitProcess());
  };

  const setData = (key, value) => {
    return setFormData({ ...formData, [key]: value });
  };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              editFormValue={null}
              // getData = {getData}
            />
          </div>
        </div>
      </div>
    );

  if (showDetailTransaksi === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            {deletePopUp.show && (
              <div>
                <ConfirmModal
                  handleIfTrue={(e) => handleDeleteTrue()}
                  handleIfFalse={(e) => handleDeleteFalse()}
                />
              </div>
            )}
            <Toaster />
            <CardTableNoAdd
              tableTitle="Tabel Detail Transaksi Pengeluaran"
              cols={transaksiKeluarDetailTableAkuntan(handleDelete)}
              data={detailTransaksi}
              handleCancelButton={handleCancelButton}
              pageNumber={pageNumber}
              changePage={changePage}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {/* {deletePopUp.show && <div><ConfirmModal handleIfTrue={(e) => handleDeleteTrue()} handleIfFalse={(e) => handleDeleteFalse()} /></div>} */}
          <Toaster />
          <CardTableNoAdd
            tableTitle="Tabel Transaksi Pengeluaran"
            cols={transaksiKeluarTableAkuntan(handleGetDetail, handleInsert)}
            data={dataTable}
            handleSearch={handleSearch}
            pageNumber={pageNumber}
            changePage={changePage}
          />
        </div>
      </div>
    </div>
  );
}
